

function getDefaultEntity(fields) {
  const defaultEntity = {}
  fields.forEach((field) => {
    defaultEntity[field.property] = ''
  })
  return defaultEntity
}

module.exports = {
  getDefaultEntity
}
